import { render, staticRenderFns } from "./PaymentMethodsModal.vue?vue&type=template&id=2c46354d"
import script from "./PaymentMethodsModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports